import React from "react";
import { Toaster } from "sonner";

interface ToastProviderProps {
  children: React.ReactNode;
}

export const ToastProvider: React.FC<ToastProviderProps> = ({ children }) => {
  return (
    <React.Fragment>
      {children}
      <Toaster 
        position="top-right"
        expand={false}
        richColors
        theme="light"
        toastOptions={{
          style: {
            borderRadius: "12px",
            padding: "16px",
            fontSize: "14px",
            fontFamily: "Inter, sans-serif"
          }
        }}
      />
    </React.Fragment>
  );
};

